import type { InfractionStatus } from "../types/infraction.types";

export const INFRACTION_STATUS = {
	NOTIFICATION_RECEIVED: "notification_received",
	AWAITING_DRIVER_INDICATION: "awaiting_driver_indication",
	DRIVER_INDICATED: "driver_indicated",
	IN_DEFENSE: "in_defense",
	PAID: "paid",
	EXPIRED: "expired",
	PAYMENT_EXPIRED: "payment_expired",
	CANCELLED: "cancelled",
	PAYMENT_PENDING: "payment_pending",
	WARNING: "warning",
} as const;

/** Rótulos alinhados ao `InfractionDisplayStatus` da API. */
export const INFRACTION_STATUS_LABEL: Record<InfractionStatus, string> = {
	[INFRACTION_STATUS.NOTIFICATION_RECEIVED]: "Notificação recebida",
	[INFRACTION_STATUS.AWAITING_DRIVER_INDICATION]: "Aguardando indicação",
	[INFRACTION_STATUS.DRIVER_INDICATED]: "Condutor indicado",
	[INFRACTION_STATUS.IN_DEFENSE]: "Em defesa",
	[INFRACTION_STATUS.PAID]: "Paga",
	[INFRACTION_STATUS.EXPIRED]: "Indicação vencida",
	[INFRACTION_STATUS.PAYMENT_EXPIRED]: "Pagamento vencido",
	[INFRACTION_STATUS.CANCELLED]: "Cancelada",
	[INFRACTION_STATUS.PAYMENT_PENDING]: "Pagamento pendente",
	[INFRACTION_STATUS.WARNING]: "Advertência",
};

/** Status exibidos no filtro da listagem (cenários operacionais da API). */
export const INFRACTION_LIST_STATUS_FILTER_OPTIONS: InfractionStatus[] = [
	INFRACTION_STATUS.NOTIFICATION_RECEIVED,
	INFRACTION_STATUS.AWAITING_DRIVER_INDICATION,
	INFRACTION_STATUS.EXPIRED,
	INFRACTION_STATUS.PAYMENT_PENDING,
	INFRACTION_STATUS.PAYMENT_EXPIRED,
	INFRACTION_STATUS.DRIVER_INDICATED,
	INFRACTION_STATUS.PAID,
	INFRACTION_STATUS.CANCELLED,
];

export const MANUAL_EDITABLE_STATUSES: InfractionStatus[] = [
	INFRACTION_STATUS.NOTIFICATION_RECEIVED,
	INFRACTION_STATUS.AWAITING_DRIVER_INDICATION,
	INFRACTION_STATUS.DRIVER_INDICATED,
	INFRACTION_STATUS.CANCELLED,
	INFRACTION_STATUS.PAYMENT_PENDING,
];

export const MANUAL_CREATE_STATUSES: InfractionStatus[] = [
	INFRACTION_STATUS.NOTIFICATION_RECEIVED,
	INFRACTION_STATUS.AWAITING_DRIVER_INDICATION,
	INFRACTION_STATUS.DRIVER_INDICATED,
	INFRACTION_STATUS.CANCELLED,
	INFRACTION_STATUS.PAYMENT_PENDING,
];

export const INFRACTION_SEVERITY = {
	LIGHT: "light",
	MEDIUM: "medium",
	SEVERE: "severe",
	VERY_SEVERE: "very_severe",
} as const;

export const INFRACTION_SEVERITY_LABEL = {
	[INFRACTION_SEVERITY.LIGHT]: "Leve",
	[INFRACTION_SEVERITY.MEDIUM]: "Média",
	[INFRACTION_SEVERITY.SEVERE]: "Grave",
	[INFRACTION_SEVERITY.VERY_SEVERE]: "Gravíssima",
} as const;
